import { render, staticRenderFns } from "./musiccategory.vue?vue&type=template&id=cd6bccc4&"
import script from "./musiccategory.vue?vue&type=script&lang=js&"
export * from "./musiccategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports